import { PropTypes } from "prop-types"
import classNames from "classnames"
import _ from "lodash"

export function Input(props) {
  const {
    ariaDescribedBy,
    className,
    disabled,
    errorId,
    inputRef,
    hasError = false,
    ...otherProps
  } = props
  const ariaDescribedByFull = _.join(_.compact([ariaDescribedBy, hasError && errorId]), " ")

  return (
    <input
      className={classNames("oj-input", className, { "state-disabled": disabled })}
      ref={inputRef}
      disabled={disabled}
      {...otherProps}
      aria-invalid={hasError}
      aria-describedby={_.isEmpty(ariaDescribedByFull) ? undefined : ariaDescribedByFull}
    />
  )
}

Input.propTypes = {
  ariaDescribedBy: PropTypes.string,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  errorId: PropTypes.string,
  hasError: PropTypes.bool,
  id: PropTypes.string.isRequired,
  inputRef: PropTypes.shape({
    current: PropTypes.instanceOf(Element)
  }),
  name: PropTypes.string.isRequired,
  readOnly: PropTypes.bool,
  required: PropTypes.bool,
  type: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool]),
  onBlur: PropTypes.func,
  onChange: PropTypes.func
}

export default Input
